import { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import type {
  PolicePresenceRequestedBody,
  ThalamosNotification,
} from "@thalamos/vision-common";
import { IncidentWorkItemIdSchema } from "@thalamos/vision-common";

import { PolicePresenceUpdatesModal } from "../../../modals/PolicePresenceUpdates/PolicePresenceUpdates.js";
import { ActionBanner } from "../../ActionBanner/ActionBanner.js";

interface PolicePresenceUpdatesNotificationProps {
  notification: ThalamosNotification;
  close: () => void;
}

export const PolicePresenceUpdatesNotification = ({
  notification,
}: PolicePresenceUpdatesNotificationProps) => {
  const { t } = useTranslation();

  const [
    isPolicePresenceUpdatesModalOpen,
    setIsPolicePresenceUpdatesModalOpen,
  ] = useState(false);
  const notificationText = notification.text as PolicePresenceRequestedBody;

  const handleClosePolicePresenceUpdatesModal = () => {
    setIsPolicePresenceUpdatesModalOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          padding: ".5rem",
        }}
      >
        <ActionBanner
          title={t("policePresenceNotification.policePresenceRequestByNHS")}
          bannerType={"warning"}
          onClick={() => {
            setIsPolicePresenceUpdatesModalOpen(true);
          }}
        />
      </Box>
      {isPolicePresenceUpdatesModalOpen && (
        <PolicePresenceUpdatesModal
          open={isPolicePresenceUpdatesModalOpen}
          close={handleClosePolicePresenceUpdatesModal}
          incidentId={IncidentWorkItemIdSchema.parse(
            notificationText.incidentWorkItemId,
          )}
          notificationId={notification.id}
        />
      )}
    </>
  );
};
